'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowDropdown = function (_React$Component) {
    _inherits(WorkflowDropdown, _React$Component);

    function WorkflowDropdown() {
        _classCallCheck(this, WorkflowDropdown);

        return _possibleConstructorReturn(this, (WorkflowDropdown.__proto__ || Object.getPrototypeOf(WorkflowDropdown)).apply(this, arguments));
    }

    _createClass(WorkflowDropdown, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.return && (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Value') && !(0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Label')) {
                var option = (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Value');
                var options = (0, _metrixCommon.getElementsByType)(this.props.component.elements, 'Options');
                if (option && options && options.some(function (x) {
                    return x.code === option;
                })) {
                    this.props.doSetReturn({ componentCode: this.props.component.code, code: 'Label', value: options.find(function (x) {
                            return x.code === option;
                        }).value });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var alwaysFetch = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'AlwaysFetch');
            var propOptions = (0, _metrixCommon.getElementsByCode)(this.props.component.elements, 'Options');
            var optionsPath = (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Options');

            var getValueByPath = function getValueByPath(obj, path) {
                var pathParts = path.split('.');
                var current = obj;

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = pathParts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var part = _step.value;

                        if (current[part] === undefined) {
                            return undefined;
                        }
                        current = current[part];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return current;
            };

            var referencesOptions = getValueByPath(this.props.reference, 'references.' + optionsPath);
            var options = alwaysFetch ? referencesOptions : propOptions;

            return _react2.default.createElement(
                _metrixCommon.Grid,
                null,
                _react2.default.createElement(
                    _metrixCommon.Row,
                    { nogutter: true },
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { nogutter: true },
                        _react2.default.createElement(_metrixCommon.Label, { text: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Label'), textAlign: _metrixCommon.Alignments.left })
                    )
                ),
                _react2.default.createElement(
                    _metrixCommon.Row,
                    null,
                    _react2.default.createElement(
                        _metrixCommon.Column,
                        { nogutter: true },
                        _react2.default.createElement(_metrixCommon.DropDown, {
                            placeholder: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Placeholder'),
                            value: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Value') && { code: (0, _metrixCommon.getReturnElementByCode)(this.props.return, 'Value') },
                            references: options,
                            referencesEvent: function referencesEvent() {
                                return _this2.props.reference.doGetReferences(optionsPath);
                            },
                            changeEvent: function changeEvent(value) {
                                _this2.props.doSetReturn({ componentCode: _this2.props.component.code, code: 'Value', value: value.code });
                                _this2.props.doSetReturn({ componentCode: _this2.props.component.code, code: 'Label', value: value.value });
                            },
                            filterMode: (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'FilterMode')
                            // alwaysFetch={alwaysFetch}
                        })
                    )
                )
            );
        }
    }]);

    return WorkflowDropdown;
}(_react2.default.Component);

exports.default = WorkflowDropdown;


WorkflowDropdown.propTypes = {
    component: _propTypes2.default.object.isRequired,
    doSetReturn: _propTypes2.default.func.isRequired,
    return: _propTypes2.default.object,
    reference: _propTypes2.default.object
};